import { Usr } from '../models/usr';
import { Fldr } from '../models/datapoint/fldr';
import { DIMsgObj } from '../models/dimsgobj';
import { UserPrivilegeFactory } from './user-privilege.factory';
import { CommonEnums } from '../common.enums';

export class SessionFactory {
    private static instance: SessionFactory;

    static getInstance() {
        if (!SessionFactory.instance) {
            SessionFactory.instance = new SessionFactory();
        }
        return SessionFactory.instance;
    }

    usr: Usr;
    fldr: Fldr;
    fldrs: Array<Fldr>;

    hasAdminAccess: string;
    hasProjects: string;
    session_Id: string;
    debugPropertiesFlag: string;
    copyObjects: string;
    enable_Streaming: string;
    enable_Scheduler: string;
    enable_AiMapping: string;
    enable_MetaView: string;
    enable_DataConnect: string;
    licValidateFlag: string;
    enable_DataProfile: string;

    isLdapUsr: string;
    licenseErrorFlag: string;
    maintenanceModeFlag: string;
    listPageSize: number;
    hasStudioPrivilege: boolean;
    hasStudioWritePrivilege: boolean;
    hasStudioExecutePrivilege: boolean;
    hasStudioViewPrivilege: boolean;
    hasScheduelrPreviliege: boolean;
    hasMonitorPreviliege: boolean;
    hasPrivilege: boolean;
    hasMetaViewPreviliege: boolean;
    enable_DataMasking: string;
    buildVersion: string;
    adminChangeFlg: string;

    /**
    * SessionFactory is a singleton class, so use SessionFactory.getInstance() method instead of creating new SessionFactory().
    */
    private constructor() {
        this.usr = new Usr();
        this.fldr = new Fldr();
        this.fldrs = new Array<Fldr>();
        this.setDefaults();
    }

    setDefaults() {
        this.usr.setDefaults();
        this.fldr.setDefaults();
        this.fldrs.splice(0, this.fldrs.length);
        this.hasStudioViewPrivilege = false;
        this.hasPrivilege = false;
        this.hasStudioPrivilege = false;
        this.hasStudioWritePrivilege = false;
        this.hasStudioExecutePrivilege = false;
        this.hasScheduelrPreviliege = false;
        this.hasMonitorPreviliege = false;
        this.hasMetaViewPreviliege = false;

        this.copyObjects = null;
        this.listPageSize = 20;

        this.hasAdminAccess = 'N';
        this.enable_DataMasking = 'N';
        this.hasProjects = 'N';
        this.session_Id = '';
        this.debugPropertiesFlag = 'N';
        this.enable_Streaming = "N";
        this.enable_AiMapping = "N";
        this.enable_Scheduler = "N";
        this.enable_MetaView = "N";
        this.enable_DataConnect = "N";
        this.licValidateFlag = "N";
        this.isLdapUsr = "N";
        this.licenseErrorFlag = "N";
        this.maintenanceModeFlag = "N";
        this.buildVersion = CommonEnums.defaults.STRING_EMPTY;
        this.adminChangeFlg = "N";
        this.enable_DataProfile = "N";
    }

    update(diMsgObj: DIMsgObj): void {
        this.usr.copyFrom(diMsgObj.retMsgObject as Usr);

        this.hasAdminAccess = diMsgObj.persistVal.hasAdminAccess ? diMsgObj.persistVal.hasAdminAccess : 'N';
        this.hasProjects = diMsgObj.persistVal.hasProjects ? diMsgObj.persistVal.hasProjects : 'N';
        this.session_Id = diMsgObj.persistVal.session_Id ? diMsgObj.persistVal.session_Id : '';
        this.debugPropertiesFlag = diMsgObj.persistVal.debugPropertiesFlag ? diMsgObj.persistVal.debugPropertiesFlag : 'N';
        this.enable_Streaming = diMsgObj.persistVal.enable_Streaming ? diMsgObj.persistVal.enable_Streaming : 'N';
        this.enable_AiMapping = diMsgObj.persistVal.enable_AiMapping ? diMsgObj.persistVal.enable_AiMapping : 'N';
        this.enable_Scheduler = diMsgObj.persistVal.enable_Scheduler ? diMsgObj.persistVal.enable_Scheduler : 'N';
        this.enable_MetaView = diMsgObj.persistVal.enable_MetaView ? diMsgObj.persistVal.enable_MetaView : 'N';
        this.enable_DataConnect = diMsgObj.persistVal.enable_DataConnect ? diMsgObj.persistVal.enable_DataConnect : 'N';
        this.licValidateFlag = diMsgObj.persistVal.licValidateFlag ? diMsgObj.persistVal.licValidateFlag : 'N';
        this.isLdapUsr = diMsgObj.persistVal.isLdapUsr ? diMsgObj.persistVal.isLdapUsr : 'N';
        this.licenseErrorFlag = diMsgObj.persistVal.licenseErrorFlag ? diMsgObj.persistVal.licenseErrorFlag : 'N';
        this.maintenanceModeFlag = diMsgObj.persistVal.maintenanceModeFlag ? diMsgObj.persistVal.maintenanceModeFlag : 'N';
        this.enable_DataMasking = diMsgObj.persistVal.enable_DataMasking ? diMsgObj.persistVal.enable_DataMasking : 'N';
        this.adminChangeFlg = diMsgObj.persistVal.adminChangeFlg ? diMsgObj.persistVal.adminChangeFlg : 'N';
        this.enable_DataProfile = diMsgObj.persistVal.enable_DataProfile ? diMsgObj.persistVal.enable_DataProfile : 'N';

    }

    updateFldrs(fldrsTmp: Array<Fldr>): void {
        let fldrsMap: Map<number, Fldr> = new Map<number, Fldr>();

        for (let i: number = 0; i < this.fldrs.length; i++) {
            fldrsMap.set(this.fldrs[i].fldr_Id, this.fldrs[i]);
        }
        this.fldrs.splice(0, this.fldrs.length);

        for (let i: number = 0; i < fldrsTmp.length; i++) {
            let fldrTmp: Fldr = fldrsTmp[i];
            let fldr: Fldr = fldrsMap.get(fldrTmp.fldr_Id);

            if (fldr) {
                fldr.copyFrom(fldrTmp);
            } else {
                fldr = Fldr.parse(fldrTmp);
            }
            fldr.imageUrl = 'assets/' + fldr.imageUrl.slice(4, fldr.imageUrl.length);
            this.fldrs.push(fldr);
        }
    }

    updateFldr(fldr: Fldr) {
        this.fldr.copyFrom(fldr);
        this.hasStudioPrivilege = UserPrivilegeFactory.getInstance().checkStudioPrivileges(this.fldr.fldr_Id);
        this.hasStudioWritePrivilege = UserPrivilegeFactory.getInstance().checkStudioWritePrivileges(this.fldr.fldr_Id);
        this.hasStudioExecutePrivilege = UserPrivilegeFactory.getInstance().checkStudioExecutePrivileges(this.fldr.fldr_Id);
        this.hasStudioViewPrivilege = UserPrivilegeFactory.getInstance().checkStudioViewPrivileges();
        this.hasScheduelrPreviliege = UserPrivilegeFactory.getInstance().checkSchedulerPrivileges(this.fldr.fldr_Id);
        this.hasMonitorPreviliege = UserPrivilegeFactory.getInstance().checkMonitorPrivileges(this.fldr.fldr_Id);
        this.hasMetaViewPreviliege = UserPrivilegeFactory.getInstance().checkMetaViewPrivileges(this.fldr.fldr_Id);
    }

    get fldr_Id(): number {
        return this.fldr.fldr_Id;
    }

    get fldr_ReusableFlag(): string {
        return this.fldr.reusableFlag;
    }

    setCfgValue(userPreferenceCfgValue): string {
        return this.debugPropertiesFlag = userPreferenceCfgValue.usr_Cfg_Val;
    }

}
